/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { CreateCategoryAction, CreateCategoryActionType, CreateCategoryState } from './types';

export const initialCreateCategoryState: CreateCategoryState = {
  loading: false,
  success: false,
  error: null,
};

export default function createCategoryReducer(
  state = initialCreateCategoryState,
  action: CreateCategoryAction,
): CreateCategoryState {
  switch (action.type) {
    case CreateCategoryActionType.CREATE_CATEGORY:
      return update(state, {
        loading: { $set: true },
      });

    case CreateCategoryActionType.CREATE_CATEGORY_SUCCESS:
      return update(state, {
        loading: { $set: false },
        success: { $set: true },
      });

    case CreateCategoryActionType.CREATE_CATEGORY_ERROR:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
      });

    case CreateCategoryActionType.CLOSE_SUCCESS_POPUP:
      return update(state, {
        success: { $set: false },
      });

    case CreateCategoryActionType.RESET_ERROR:
      return update(state, {
        error: { $set: null },
      });

    default:
      return state;
  }
}
